export class OperatorView {
    id: number;
    name: string;
    pin: number;
}
